import { render, staticRenderFns } from "./ComposedTitle.vue?vue&type=template&id=5ce2af10"
import script from "./ComposedTitle.vue?vue&type=script&lang=js"
export * from "./ComposedTitle.vue?vue&type=script&lang=js"
import style0 from "./ComposedTitle.vue?vue&type=style&index=0&id=5ce2af10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports